module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point3_4-ac645fb5d0eea0935c152fb8442eb8ea.jpg";